/**************************************************
 * Nombre:       Inicio_Portada_Bienvenida
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import portada from "../../../Recursos/portada_inicio.png";
import portada_cell from "../../../Recursos/portada_inicio_cell.png";
import Tarjeta_Documento_Inicio from "../../Tarjetas/Tarjeta_Documento_Inicio";
import React, {useContext, useEffect} from "react";
import {usuarioContext} from "../../../App";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Inicio_Portada_Bienvenida = () => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const [documentos, setDocumentos] = React.useState([])

    useEffect(() => {

        if (cData.usuario && cData.usuario.pais) {

            let pais = cData.usuario.pais
            let w = [where('pais', 'in', [pais, 'Todos'])]
            obtenerColWheres({col: 'documentosReqs', wheres: w}).then((dox) => {
                if (dox.res && dox.data && dox.data[0]) {
                    let docs = dox.data[0].documentos
                    if (docs && docs.length > 0) {
                        setDocumentos(docs)
                    }

                }
            })
        }


    }, [cData])
    return (
        <Grid
            container
            justifyContent={'flex-end'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: sCell ? `linear-gradient(359deg, #8531FD 66.75%, rgba(133, 49, 253, 0.10) 98.95%), url(${portada_cell})` : `linear-gradient(270deg, #8531FD 48.22%, rgba(133, 49, 253, 0.10) 69.84%), url(${portada})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: sCell ? 'center' : 'rigth center',
                p: sCell ? 2 : 4,
                mt: sCell ? -2 : 0
            }}
        >


            <Grid container size={{xs: 12, sm: 7, md: 7}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-end'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{color: '#FFF'}}
                    spacing={0}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-end', mt: sCell ? 30 : 1}}>
                        <Typography
                            sx={{
                                fontSize: 36,
                                fontWeight: 800,
                                lineHeight: 1.1,
                                textAlign: sCell ? 'center' : 'right'
                            }}>Te
                            doy la bienvenida</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 1.5}}>
                        <Typography sx={{fontSize: 14, fontWeight: 400, textAlign: sCell ? 'center' : 'right'}}>
                            Bienvenido al Sistema Educativo Empresarial Nebo System, Aquí encontrarás una comunidad comprometida y
                            un sistema de formación diseñado para brindarte las herramientas, el acompañamiento y la
                            motivación necesarios para transformar tus sueños en logros reales y alcanzar el éxito que
                            mereces.
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 2}}>
                        <Typography sx={{fontSize: 14, fontWeight: 600, textAlign: sCell ? 'center' : 'right'}}>Es
                            importante que me cargues los siguientes documentos y fotos:</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 4, px: 2}}>
                        <Grid
                            container
                            justifyContent={'flex-end'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={3}
                        >

                            {documentos.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 6, sm: 4, md: 3}}
                                          sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Documento_Inicio item={it}/>
                                    </Grid>
                                )
                            })}

                        </Grid>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Inicio_Portada_Bienvenida

